import * as React from 'react';
import './SelectAgeBar.scss';
import MonthlyStatementModel from 'src/model/monthlyStatement.model';

export interface ISelectAgeBarProps {
  selectedOption: number;
  handleOptionChange(option: number): void;
  getMonthlyStatement(page: number, period: number, size: number): void;
  monthlyStatementContent: MonthlyStatementModel;
  t?: any;
}

const SelectAgeBar: React.SFC<ISelectAgeBarProps> = props => {
  const { t } = props;
  return (
    <div className="rp-account-statement--select-age-bar-container">
      <input
        id="radio1"
        type="radio"
        value={1}
        checked={props.selectedOption === 1}
        onChange={e => {
          props.handleOptionChange(Number(e.target.value));
        }}
      />
      <label
        htmlFor="radio1"
        className={`col-md-4 rp-account-statement--select-age-bar ${
          props.selectedOption === 1 ? 'rp-acc-statement-active' : ''
        }`}
        onClick={() => {
          props.getMonthlyStatement(0, 1, 20);
        }}
      >
        {t('accountMonthlyStatements.currentMonthTab')}
      </label>

      <input
        id="radio2"
        type="radio"
        value={2}
        checked={props.selectedOption === 2}
        onChange={e => {
          props.handleOptionChange(Number(e.target.value));
        }}
      />
      <label
        htmlFor="radio2"
        className={`col-md-4 rp-account-statement--select-age-bar ${
          props.selectedOption === 2 ? 'rp-acc-statement-active' : ''
        }`}
        onClick={() => {
          props.getMonthlyStatement(0, 2, 20);
        }}
      >
        {t('accountMonthlyStatements.previousMonthTab')}
      </label>

      <input
        id="radio3"
        type="radio"
        value={3}
        checked={props.selectedOption === 3}
        onChange={e => {
          props.handleOptionChange(Number(e.target.value));
        }}
      />
      <label
        htmlFor="radio3"
        className={`col-md-4 rp-account-statement--select-age-bar ${
          props.selectedOption === 3 ? 'rp-acc-statement-active' : ''
        }`}
        onClick={() => {
          props.getMonthlyStatement(0, 3, 20);
        }}
      >
        {t('accountMonthlyStatements.threeMonthsPriorTab')}
      </label>
    </div>
  );
};

export default SelectAgeBar;
